export default {
  description: {
    en: 'These are your family members',
    ar: 'هؤلاء هم أفراد عائلتك'
  },
  add: {
    en: 'Add another',
    ar: 'أضف آخر'
  },
  finish: {
    en: 'Done!',
    ar: 'تم!'
  }
};
